/**
 * In-memory store for PII (e.g. national_id) that must not be persisted to localStorage. Used for compliance (e.g. PII / data minimization). Data is lost on page refresh.
 */
let _nationalId = null;

export function setNationalIdInMemory(value) {
	_nationalId = value ?? null;
}

export function getNationalIdInMemory() {
	return _nationalId;
}

export function clearNationalIdInMemory() {
	_nationalId = null;
}
